/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const SupplierLimitationsType = {
    None: 'None',
    HasRoomTypeLimitation: 'HasRoomTypeLimitation',
    HasServiceLevelLimitation: 'HasServiceLevelLimitation'
} as const;

export type SupplierLimitationsType = typeof SupplierLimitationsType[keyof typeof SupplierLimitationsType];



